<div class="policy-header k-d-flex k-d-flex-row k-mb-3">
    <h2 mat-dialog-title *ngIf="timeOffPolicy">{{ 'EditPolicy' | translate: {Default: 'Edit Policy'} }}</h2>
    <h2 mat-dialog-title *ngIf="!timeOffPolicy">{{ 'CreateAPolicy' | translate: {Default: 'Create a Policy'} }}</h2>

    <div class="k-d-flex k-d-flex-row k-align-items-center">
        <button
            type="button"
            color="warn"
            mat-icon-button
            aria-label="Delete policy"
            appPreventDoubleClick
            (throttledClick)="showDeletePolicyConfirmation()"
            *ngIf="timeOffPolicy?.id"
            matTooltip="Delete policy"
            class="delete-button"
        >
            <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
        </button>

        <button
            type="button"
            mat-icon-button
            aria-label="Close policy form"
            class="close-button"
            appPreventDoubleClick
            (throttledClick)="close()"
        >
            <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="isLoading" style="display: flex; flex-direction: column; gap: 12px; width: 100%; background: white; padding: 12px 0;">
    <ngx-skeleton-loader
        count="8"
        [theme]="{ 'height.px': 52, 'margin-bottom.px': 12, 'border-radius.px': 6 }"
    ></ngx-skeleton-loader>
</div>

<div class="form-container" *ngIf="!isLoading" [formGroup]="policyForm">

    <div class="lookup-form-row">
        <mat-form-field appearance="fill">
            <mat-label>
                {{ 'TimeOffType' | translate: {Default: 'Time Off Type'} }}
            </mat-label>

            <mat-select disableOptionCentering formControlName="timeOffType" [disabled]="timeOffType">
                <mat-option *ngFor="let tot of timeOffTypeList" [value]="tot.id">{{tot.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <app-localization-text-form-field
        [formElement]="policyNameField"
        [parentGroup]="policyForm"
        [cultures]="cultures"
        (emitAddtoFormArray)="addLocalizationFromComponent($event)"
        (emitDeleteFromFormArray)="deleteLocalizationFromComponent($event)"
    ></app-localization-text-form-field>

    <div class="k-mb-3">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="NoLimitPolicy" formControlName="noLimitPolicy">
            {{ 'NoLimitPolicy' | translate: {Default: 'No Limit Policy'} }}
         </mat-slide-toggle>
    </div>
    
    <div class="k-mb-3" *ngIf="!policyForm?.value?.noLimitPolicy">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="ShowMaximumCarryOverToEndUser" formControlName="showMaximumCarryOverToEndUser">
            {{ 'ShowMaximumCarryOverToEndUser' | translate: {Default: 'Show Maximum Carry Over To End User'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="ShowCarryOverDateToEndUser" formControlName="showCarryOverDateToEndUser">
            {{ 'ShowCarryOverDateToEndUser' | translate: {Default: 'Show Carry Over Date To End User'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3" *ngIf="!policyForm?.value?.noLimitPolicy">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="ProrateHireDate" formControlName="prorateHireDate">
            {{ 'ProrateHireDate' | translate: {Default: 'Prorate Hire Date'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="disregardCarryOverForRemainingCalculation" formControlName="disregardCarryOverForRemainingCalculation">
            {{ 'disregardCarryOverForRemainingCalculation' | translate: {Default: 'Disregard Carry Over For Remaining Calculation'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="PermitNegativeAllocation" formControlName="permitNegativeAllocation">
            {{ 'PermitNegativeAllocation' | translate: {Default: 'Permit Negative Allocation'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3">
        <mat-slide-toggle setColor="primaryColour" class="fte-prorated" appLocalizationPopupDirective localizationCode="CombineScheduleAllocations" formControlName="combineScheduleAllocations">
            {{ 'CombineScheduleAllocations' | translate: {Default: 'Combine Schedule Allocations'} }}
        </mat-slide-toggle>
    </div>

    <div class="k-mb-3" appLocalizationPopupDirective localizationCode="TimeOff-RoundingType">
        <mat-form-field appearance="fill">
            <mat-label>
                {{ 'TimeOff-RoundingType' | translate: {Default: 'Rounding Type'} }}
            </mat-label>
    
            <mat-select disableOptionCentering formControlName="roundingType">
                <mat-option *ngFor="let timeOffRoundType of timeOffRoundTypes.data" [value]="timeOffRoundType.id">{{timeOffRoundType.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="k-mb-3" appLocalizationPopupDirective localizationCode="TimeOff-RoundTo">
        <mat-form-field appearance="fill">
            <mat-label>
                {{ 'TimeOff-RoundTo' | translate: {Default: 'Round To'} }}
            </mat-label>
    
            <mat-select disableOptionCentering formControlName="roundTo">
                <mat-option *ngFor="let timeOffRoundTo of timeOffRoundTos.data" [value]="timeOffRoundTo.id">{{timeOffRoundTo.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <section class="form-section-card accrual-options-card">
        <div class="form-section-title">
            <h6>
                {{ 'AccrualOptions' | translate: {Default: 'Accrual Options'} }}
            </h6>
        </div>
        <div class="accrual-options-row">

            <mat-slide-toggle setColor="primaryColour" class="fte-prorated" formControlName="fteProrated" *ngIf="!policyForm?.value?.noLimitPolicy">
                {{ 'FTEProrated' | translate: {Default: 'FTE Prorated'} }}
            </mat-slide-toggle>

            <div class="carry-over-card">
                <label class="radio-group-label">
                    {{ 'CarryOver' | translate: {Default: 'Carry Over'} }}
                </label>
                <mat-radio-group class="tp-radio-group" formControlName="carryOverUseHireDate">
                    <mat-radio-button setColor="primaryColour" class="tp-radio-button" [value]="true" (change)="clearDayAndMonth($event)">
                        {{ 'HireDate' | translate: {Default: 'Hire Date'} }}
                    </mat-radio-button>
                    <mat-radio-button setColor="primaryColour" class="tp-radio-button" [value]="false">
                        <span class="radio-inline-label">{{ 'SetDate' | translate: {Default: 'Set Date'} }}</span>
                        <div class="carry-over-fields" *ngIf="policyForm.value.carryOverUseHireDate === false">
                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ 'Day' | translate: {Default: 'Day'} }}
                                </mat-label>

                                <input matInput type="number" formControlName="carryOverDay">
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ 'Month' | translate: {Default: 'Month'} }}
                                </mat-label>

                                <input matInput type="number" formControlName="carryOverMonth">
                            </mat-form-field>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </section>

    <div class="lookup-form-row" *ngIf="!policyForm?.value?.noLimitPolicy">
        <mat-form-field appearance="fill">
            <mat-label>
                {{ 'AccruedAt' | translate: {Default: 'Accrued At'} }}
            </mat-label>

            <mat-select disableOptionCentering formControlName="accruedAt">
                <mat-option *ngFor="let timeOffAccruedAt of timeOffAccruedAtList" [value]="timeOffAccruedAt.id">{{timeOffAccruedAt.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- <div class="lookup-form-row">
        <mat-form-field appearance="fill">
            <mat-label>
                First Accrual Type
            </mat-label>

            <mat-select disableOptionCentering formControlName="firstAccrual">
                <mat-option *ngFor="let timeOffFirstAccrualType of timeOffFirstAccrualTypeList" [value]="timeOffFirstAccrualType.id">{{timeOffFirstAccrualType.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div> -->


    <ng-container *ngIf="timeOffType && !policyForm?.value?.noLimitPolicy">
        <section class="form-section-card accrual-schedule-card">
            <div class="form-section-title">
                <h6>
                    {{ 'AccrualSchedule' | translate: {Default: 'Accrual Schedule'} }}
                </h6>
            </div>
            <ng-container *ngIf="!editOrCreateScheduleMode">
                <div class="schedule-list" *ngIf="timeOffPolicySchedules?.length; else emptyScheduleState">
                    <div class="schedule-item" *ngFor="let timeOffPolicySchedule of timeOffPolicySchedules; let i = index">
                        <div class="schedule-copy">
                            <p>{{ 'StartAt' | translate: {Default: 'Start at'} }} {{timeOffPolicySchedule.startsAt}} {{timeOffPolicySchedule.startAtUnit.name}} {{ 'AfterHire' | translate: {Default: 'after hire'} }}.<br>
                                Accrued at a rate of {{timeOffPolicySchedule.accrualRate}} hour(s) per {{timeOffPolicySchedule.accrualRateInterval.name}}

                                <span *ngIf="timeOffPolicySchedule.intervalStartDate !== null"><br>starting on {{timeOffPolicySchedule.intervalStartDate | date:'mediumDate'}}</span>

                                <span *ngIf="timeOffPolicySchedule?.accrualRateInterval?.id === 'Year'">
                                    on {{getMonthText(timeOffPolicySchedule.yearlyMonth)}} {{timeOffPolicySchedule.yearlyDay}}{{ordinalDateSuffix(timeOffPolicySchedule.yearlyDay)}}
                                </span>

                                .<br>

                                <span *ngIf="timeOffPolicySchedule?.accrualRateInterval?.id === 'BiMonthly'">
                                    On the {{timeOffPolicySchedule.biMonthlyFirstDay}}{{ordinalDateSuffix(timeOffPolicySchedule.biMonthlyFirstDay)}} day of the month and the
                                    <span *ngIf="timeOffPolicySchedule?.biMonthlySecondDayEndOfMonth === true"> last day of the month.</span>
                                    <span *ngIf="!timeOffPolicySchedule?.biMonthlySecondDayEndOfMonth === true"> {{timeOffPolicySchedule.biMonthlySecondDay}}{{ordinalDateSuffix(timeOffPolicySchedule.biMonthlySecondDay)}} day of the month.</span>
                                    <br>
                                </span>

                                <span *ngIf="timeOffPolicySchedule?.accrualRateInterval?.id === 'Month'">
                                    <span *ngIf="timeOffPolicySchedule?.monthlyDay">On the {{timeOffPolicySchedule.monthlyDay}}{{ordinalDateSuffix(timeOffPolicySchedule.monthlyDay)}} day of the month.</span>
                                    <span *ngIf="timeOffPolicySchedule?.monthlyEndOfMonth === true">On the last day of the month.</span>
                                    <span *ngIf="timeOffPolicySchedule?.monthlyOnHireDay === true">On the Hire Day.</span>
                                    <br>
                                </span>

                                Maximum accrual of {{timeOffPolicySchedule.accrualMaximum}} hour(s).<br>
                                Maximum carry over amount of {{timeOffPolicySchedule.carryOverAmount}} hour(s).
                            </p>
                        </div>
                        <div class="schedule-actions">
                            <mat-icon
                                    class="material-icons-outlined"
                                    appPreventDoubleClick (throttledClick)="editSchedule(timeOffPolicySchedule); $event.stopPropagation();"
                                    matTooltip="Edit"
                            >edit
                            </mat-icon>
                            <mat-icon class="material-icons-outlined" appPreventDoubleClick (throttledClick)="showDeleteScheduleConfirmation(timeOffPolicySchedule.id)" matTooltip="Delete">delete</mat-icon>
                        </div>
                    </div>
                </div>

                <ng-template #emptyScheduleState>
                    <div class="empty-schedule-state">
                        <p>No accrual schedules added yet.</p>
                    </div>
                </ng-template>

                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="addPolicySchedule()" class="schedule-add-button k-mb-2">
                    <mat-icon aria-hidden="false" class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                    {{ 'AddSchedule' | translate: {Default: 'Add Schedule'} }}
                </button>
            </ng-container>

            <div class="accrual-schedule-form schedule-editor-card" [formGroup]="scheduleForm" *ngIf="editOrCreateScheduleMode">
                <div class="form-container schedule-editor-inner">
                    <p class="k-font-weight-bold">{{editTimeOffPolicySchedule ? 'Edit' : 'Add' }} Schedule</p>
                    <ng-container>
                        <div class="form-row">
                            <mat-form-field appearance="fill" class="k-mr-3">
                                <mat-label>
                                    {{ 'StartAt' | translate: {Default: 'Start at'} }}
                                </mat-label>

                                <input matInput
                                       type="number"
                                       min="0"
                                       max="99999"
                                       formControlName="startsAt"
                                       placeholder="1"
                                >
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ 'StartAtUnit' | translate: {Default: 'Start at Unit'} }}
                                </mat-label>

                                <mat-select disableOptionCentering formControlName="startAtUnit">
                                    <mat-option *ngFor="let timeOffStartAtUnit of timeOffStartAtUnitList" [value]="timeOffStartAtUnit.id">{{timeOffStartAtUnit.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="fill" class="k-mr-3">
                                <mat-label>
                                    {{ 'AccruedAtARateOf' | translate: {Default: 'Accrued at a rate of'} }}
                                </mat-label>

                                <input matInput
                                       type="number"
                                       min="0"
                                       max="99999"
                                       formControlName="accrualRate"
                                       placeholder="1"
                                >
                            </mat-form-field>

                            <mat-form-field appearance="fill" >
                                <mat-label>
                                    {{ 'AccrualRateInterval' | translate: {Default: 'Accrual Rate Interval'} }}
                                </mat-label>

                                <mat-select disableOptionCentering formControlName="accrualRateInterval">
                                    <mat-option *ngFor="let timeOffAccrualRateInterval of timeOffAccrualRateIntervalList" [value]="timeOffAccrualRateInterval.id">{{timeOffAccrualRateInterval.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill" *ngIf="!hideIntervalStartDate" class="k-ml-3">
                                <mat-label>
                                    {{ 'IntervalStartDate' | translate: {Default: 'Interval Start Date'} }}
                                </mat-label>

                                <input matInput [matDatepicker]="intervalStartDatePicker" formControlName="intervalStartDate">
                                <span fxLayout="row" matSuffix>
                                    <mat-datepicker-toggle [for]="intervalStartDatePicker"></mat-datepicker-toggle>
                                </span>
                                <mat-datepicker #intervalStartDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="form-row" *ngIf="!hideYearlyMonthDay">
                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ 'YearlyMonth' | translate: {Default: 'Yearly Month'} }}
                                </mat-label>

                                <mat-select disableOptionCentering formControlName="yearlyMonth" >
                                    <mat-option *ngFor="let month of months" [value]="month.value">{{month.text}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill"  class="k-ml-3">
                                <mat-label>
                                    {{ 'YearlyDay' | translate: {Default: 'Yearly Day'} }}
                                </mat-label>

                                <mat-select disableOptionCentering formControlName="yearlyDay">
                                    <mat-option *ngFor="let number of numberOfDays" [value]="number">{{number}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="form-row month-details" *ngIf="!hideMonthDetails">

                            <section class="example-section">
                                <label class="example-margin">{{ 'MonthlyAccrualDay' | translate: {Default: 'Monthly Accrual Day'} }}</label>
                                <mat-radio-group formControlName="monthlyAccrualDayRadioValue">
                                    <mat-radio-button class="example-margin" value="monthlyEndOfMonth">{{ 'MonthlyEndOfMonth' | translate: {Default: 'End Of Month'} }}</mat-radio-button>
                                    <mat-radio-button class="example-margin" value="monthlyOnHireDay">{{ 'MonthlyOnHireDay' | translate: {Default: 'On Hire Day'} }}</mat-radio-button>
                                    <mat-radio-button class="example-margin" value="monthlyDay">{{ 'DayOfMonth' | translate: {Default: 'Day of Month'} }}</mat-radio-button>
                                </mat-radio-group>
                            </section>

                            <mat-form-field class="monthly-day-form-field" appearance="fill" *ngIf="scheduleForm.get('monthlyAccrualDayRadioValue').value === 'monthlyDay'">
                                <mat-label>
                                    {{ 'DayOfMonth' | translate: {Default: 'Day of Month'} }}
                                </mat-label>

                                <input matInput type="number" min="1" max="28" formControlName="monthlyDay">

                                <span matTextSuffix>{{ordinalDateSuffix(scheduleForm.get('monthlyDay').value)}}</span>

                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlyFirstDay.errors?.min">
                                    {{ 'MustBeAtLeast' | translate: {Default: "Must be at least"} }} 1
                                </div>
                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlyFirstDay.errors?.max">
                                    {{ 'CannotBeMoreThan' | translate: {Default: "Cannot be more than"} }} 28
                                </div>
                            </mat-form-field>
                        </div>

                        <div class="form-row" *ngIf="!hideBiMonthlyFormFields">
                            <mat-form-field appearance="fill" class="k-mr-3">
                                <mat-label>
                                    {{ 'BiMonthlyFirstDate' | translate: {Default: 'Bi Monthly First Date'} }}
                                </mat-label>

                                <input matInput type="number" formControlName="biMonthlyFirstDay">

                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlyFirstDay.errors?.min">
                                    {{ 'MustBeAtLeast' | translate: {Default: "Must be at least"} }} 1
                                </div>
                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlyFirstDay.errors?.max">
                                    {{ 'CannotBeMoreThan' | translate: {Default: "Cannot be more than"} }} 31
                                </div>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="k-mr-3">
                                <mat-label>
                                    {{ 'BiMonthlySecondDate' | translate: {Default: 'Bi Monthly Second Date'} }}
                                </mat-label>

                                <input matInput type="number" formControlName="biMonthlySecondDay">

                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlySecondDay.errors?.min">
                                    {{ 'MustBeAtLeast' | translate: {Default: "Must be at least"} }} 1
                                </div>
                                <div class="error-text" *ngIf="scheduleFormControls.biMonthlySecondDay.errors?.max">
                                    {{ 'CannotBeMoreThan' | translate: {Default: "Cannot be more than"} }} 31
                                </div>
                            </mat-form-field>

                            <mat-slide-toggle formControlName="biMonthlySecondDayEndOfMonth">
                                {{ 'BiMonthlySecondDateEndOfMonth' | translate: {Default: 'Bi Monthly Second Date End Of Month'} }}
                            </mat-slide-toggle>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="fill" class="k-mr-3">
                                <mat-label>
                                    {{ 'MaximumAccrual' | translate: {Default: 'Maximum Accrual'} }}
                                </mat-label>

                                <input matInput
                                       type="number"
                                       min="0"
                                       max="99999"
                                       formControlName="accrualMaximum"
                                       placeholder="1"
                                >
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>
                                    {{ 'CarryOverAmount' | translate: {Default: 'Carry Over Amount'} }}
                                </mat-label>

                                <input matInput
                                       type="number"
                                       min="0"
                                       max="99999"
                                       formControlName="carryOverAmount"
                                       placeholder="1"
                                >
                            </mat-form-field>
                        </div>

                        <div class="form-button-row k-mb-2">
                            <button mat-raised-button appPreventDoubleClick (throttledClick)="discardScheduleChanges()">{{ 'DiscardSchedule' | translate: {Default: 'Discard Schedule'} }} {{editTimeOffPolicySchedule ? 'Changes' : '' }}</button>
                            <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="saveSchedule()" [disabled]="!scheduleForm.valid">{{editTimeOffPolicySchedule ? 'Save Schedule Changes' : 'Add Schedule' }}</button>
                        </div>

                    </ng-container>
                </div>
            </div>
        </section>
    </ng-container>

    <div class="form-buttons">
        <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="savePolicy()" [disabled]="!policyForm?.valid">{{ 'Save' | translate: {Default: 'Save'} }}</button>
    </div>
</div>
